import GenericModal from '../GenericModal';
import styles from './ExitWithoutSavingModal.module.scss';
import { FunctionComponent, useState } from 'react';
import Button from 'components/UI/V3/Button/Button';

interface ExitWithoutSavingModalProps {
    onDiscard: () => void;
    onKeepEditing: () => void;
}

const ExitWithoutSavingModal: FunctionComponent<ExitWithoutSavingModalProps> = props => {
    const [loading, setLoading] = useState(false);

    return (
        <GenericModal
            footer={
                <div className={styles.footer}>
                    <div className={styles.left}>
                        <Button
                            className={styles.button}
                            label="Discard"
                            onClick={props.onDiscard}
                            variant="danger"
                            isLoading={loading}
                        />
                    </div>
                    <div className={styles.right}>
                        <Button
                            className={styles.button}
                            label="Keep Editing"
                            onClick={props.onKeepEditing}
                            variant="outlined"
                        />
                    </div>
                </div>
            }
            onClose={props.onKeepEditing}
        >
            <span className={styles.title}>Exit Without Saving?</span>
            <span className={styles.text}>Your unsaved changes will be lost.</span>
        </GenericModal>
    );
};

export default ExitWithoutSavingModal;
